import { Component, createRef } from "react";
import { renderIntoDocument } from "react-dom/cjs/react-dom-test-utils.production.min";
import "./custom_carousel.css";

export default class CustomCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Scrolling variables
      isMouseDown: false,
      isScrolling: false,
      showLeftArrow: false,
      showRightArrow: true,

      // Sizing and placement variables
      itemWidth: 0,
      itemHeight: 0,
      itemGapX: 0,
      itemGapY: 0,
      wrapperPaddingX: 0,
      wrapperPaddingY: 0,

      debugString: "",
    };

    // Scrolling variables
    this.touchId = -1;
    this.startMSOffsetX = 0; // Initial Mouse-Scroll(MS) offset
    this.startMSOffsetY = 0; // Initial Mouse-Scroll(MS) offset
    this.startScrollTop = 0;
    this.startTime = 0;
    this.updateTime = 0;
    this.mousePosX = 0;
    this.mousePosY = 0;
    this.speedY = 0;
    this.speedMultiplier = 0.5;
    this.damping = 0.975; //0.9;
    this.scrollRatio = 1.0;
    this.magnetScrollTopInitial = 0;
    this.magnetScrollTargetIndex = 0;
    this.magnetStartTime = 0;
    this.magnetScrollTime = 0.5; // in seconds
    this.isMagneticallyScrolling = false;
    this.scrollTimeMultiplier = 1.0;
    this.isMobile = false;

    // Sizing and placement variables
    this.itemMaxWidthRatio = 1.0;
    this.itemMaxHeightRatio = 0.6; // 0.25
    this.itemAspect = 16.0 / 9.0;
    this.itemGapXRatio = 0.75;
    this.itemGapY = 50; //25;
    this.singleItemScrollTop = 0;

    this._carouselWrapper = createRef();
    this._carouselContainer = createRef();
  }

  componentDidMount = () => {
    this._carouselWrapper.current.addEventListener(
      "mouseenter",
      this.onMouseEnter //this.onMouseUp
    );
    this._carouselWrapper.current.addEventListener(
      "mousedown",
      this.onMouseDown
    );
    this._carouselWrapper.current.addEventListener(
      "touchstart",
      this.onTouchStart
    );
    this._carouselWrapper.current.addEventListener(
      "mousemove",
      this.onMouseMove
    );
    this._carouselWrapper.current.addEventListener(
      "touchmove",
      this.onTouchMove
    );
    this._carouselWrapper.current.addEventListener("mouseup", this.onMouseUp);
    this._carouselWrapper.current.addEventListener("touchend", this.onTouchEnd);
    this._carouselWrapper.current.addEventListener(
      "mouseleave",
      this.onMouseLeave //this.onMouseUp
    );
    this._carouselWrapper.current.addEventListener(
      "touchcancel",
      this.onTouchEnd // this.onMouseLeave
    );
    this._carouselWrapper.current.addEventListener("wheel", this.onMouseWheel);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  };

  componentWillUnmount = () => {
    this._carouselWrapper.current.removeEventListener(
      "mouseenter",
      this.onMouseEnter //this.onMouseUp
    );
    this._carouselWrapper.current.removeEventListener(
      "mousedown",
      this.onMouseDown
    );
    this._carouselWrapper.current.removeEventListener(
      "touchstart",
      this.onTouchStart
    );
    this._carouselWrapper.current.removeEventListener(
      "mousemove",
      this.onMouseMove
    );
    this._carouselWrapper.current.removeEventListener(
      "touchmove",
      this.onTouchMove
    );
    this._carouselWrapper.current.removeEventListener(
      "mouseup",
      this.onMouseUp
    );
    this._carouselWrapper.current.removeEventListener(
      "touchend",
      this.onTouchEnd
    );
    this._carouselWrapper.current.removeEventListener(
      "mouseleave",
      this.onMouseLeave // this.onMouseUp
    );
    this._carouselWrapper.current.removeEventListener(
      "touchcancel",
      this.onTouchEnd //this.onMouseLeave
    );
    this._carouselWrapper.current.removeEventListener(
      "wheel",
      this.onMouseWheel
    );

    window.removeEventListener("resize", this.onResize);
  };

  onMouseEnter = (e) => {
    this.preventDefaultCustom(e);
    document.addEventListener("wheel", this.preventDefaultCustom, {
      passive: false,
    });
  };
  onMouseDown = (e) => {
    this.preventDefaultCustom(e);
    console.log("Mouse down");
    this.onDragStart(e.pageX, e.pageY);
  };
  onTouchStart = (e) => {
    this.preventDefaultCustom(e);
    if (this.touchId >= 0) return;

    console.log("Touch start");
    var touches = e.changedTouches;
    if (touches.length === 0) return;
    this.touchId = touches[0].identifier;
    if (this.touchId >= 0) this.onDragStart(touches[0].pageX, touches[0].pageY);
  };
  onDragStart = (dragPointX, dragPointY) => {
    this.state.isMouseDown = true;
    this.setState({ isMouseDown: true });
    this.startMSOffsetX = dragPointX; // - this._carouselWrapper.current.offsetLeft;
    this.startMSOffsetY = dragPointY; // - this._carouselWrapper.current.offsetTop;
    this.startScrollTop = this._carouselWrapper.current.scrollTop;
    this.startTime = this.updateTime = Date.now();
    this.mousePosX = dragPointX;
    this.mousePosY = dragPointY;
  };

  onMouseMove = (e) => {
    this.preventDefaultCustom(e);
    this.onDrag(e.pageX, e.pageY);
  };
  onTouchMove = (e) => {
    this.preventDefaultCustom(e);
    if (this.touchId < 0) return;

    console.log("Touch move");
    var touches = e.changedTouches;
    if (touches.length === 0) return;
    for (let i = 0; i < touches.length; i++) {
      if (touches[i].identifier === this.touchId) {
        this.onDrag(touches[i].pageX, touches[i].pageY);
        break;
      }
    }
  };
  onDrag = (dragPointX, dragPointY) => {
    if (!this.state.isMouseDown) return;
    this.setState({ isScrolling: true });
    this.isMagneticallyScrolling = false;

    const scrollX = dragPointX - this.startMSOffsetX; // - this._carouselWrapper.current.offsetLeft;
    const scrollY = dragPointY - this.startMSOffsetY; // - this._carouselWrapper.current.offsetTop;
    // const scrollAmt = Math.max(currMSOffsetX - this.startMSOffsetX, currMSOffsetY - this.startMSOffsetY);

    let scrollLeftAmt;

    // console.log("scrollX / scrollY", scrollX / scrollY);
    // if (Math.abs(scrollX / scrollY) > this.scrollRatio) {
    //   scrollLeftAmt = scrollX;
    // } else {
    //   scrollLeftAmt = scrollY * this.scrollRatio;
    // }
    scrollLeftAmt = scrollY * this.scrollRatio;

    let newScrollTop = this.startScrollTop - scrollY;
    this.checkArrowVisibility(newScrollTop);
    this._carouselWrapper.current.scrollTop = newScrollTop;
    this._carouselWrapper.current.scrollLeft = newScrollTop * this.scrollRatio;

    // let distDelta = dragPointX - this.mousePosX;
    let distDelta = dragPointY - this.mousePosY;
    let timeDelta = Date.now() - this.updateTime;
    this.speedY = (distDelta * this.speedMultiplier) / timeDelta;

    this.updateTime = Date.now();
    this.mousePosX = dragPointX;
    this.mousePosY = dragPointY;

    this.getNearestItem();
  };

  onMouseUp = (e) => {
    this.preventDefaultCustom(e);
    console.log("Mouse up");
    this.onDragEnd(e.target.id);
  };
  onTouchEnd = (e) => {
    this.preventDefaultCustom(e);
    if (this.touchId < 0) return;

    console.log("Touch end");
    var touches = e.changedTouches;
    if (touches.length === 0) return;
    for (let i = 0; i < touches.length; i++) {
      if (touches[i].identifier === this.touchId) {
        this.onDragEnd(e.target.id);
        this.touchId = -1;
        break;
      }
    }
  };
  onDragEnd = (targetId) => {
    console.log("On drag end");
    this.state.isMouseDown = false;
    this.setState({ isMouseDown: false });
    let endTime = Date.now();

    console.log("Click Speed", this.speedY);
    console.log("Click Time", endTime - this.startTime);
    console.log(targetId);

    if (
      endTime - this.startTime < 250 &&
      (Math.abs(this.speedY) < 0.1 || !this.state.isScrolling)
    ) {
      // if (endTime - this.startTime < 100 && Math.abs(this.speedY) < 0.5) {
      // Was this a click instead of drag?
      console.log("Click!");

      let clickTargetItemIndex = -1;
      if (!targetId) {
        console.log("Didn't click on an item");
      } else {
        for (let i = 0; i < this.props.children.length; i++) {
          if (this.props.children[i].props.id === targetId) {
            console.log("Clicked item at index: " + i);
            clickTargetItemIndex = i;
            break;
          }
        }
      }

      // this.setState({ isScrolling: false });
      this.getNearestItem();
      this.scrollTimeMultiplier = 1.0;
      if (clickTargetItemIndex >= 0) {
        this.props.onClick(clickTargetItemIndex);
        this.magnetScrollTargetIndex = clickTargetItemIndex;
      }
      this.startScrollMagnetically();
    } else if (endTime - this.updateTime < 250) {
      // ???
      console.log("Slow Scroll");
      requestAnimationFrame(this.scrollSlowDown);
    } else {
      console.log("STOP!");
      console.log(endTime - this.startTime);
      this.getNearestItem();
      this.scrollTimeMultiplier = 1.0;
      this.startScrollMagnetically();
    }
  };

  onMouseLeave = (e) => {
    this.preventDefaultCustom(e);
    console.log("Mouse leave");
    this.setState({ isMouseDown: false });
    document.removeEventListener("wheel", this.preventDefaultCustom, false);
  };
  onTouchCancel = (e) => {
    this.preventDefaultCustom(e);
    if (this.touchId < 0) return;

    console.log("Touch cancel");
    var touches = e.changedTouches;
    if (touches.length === 0) return;
    for (let i = 0; i < touches.length; i++) {
      if (touches[i].identifier === this.touchId) {
        this.setState({ isMouseDown: false });
        this.touchId = -1;
        break;
      }
    }
  };

  preventDefaultCustom = (e) => {
    e = e || window.event;
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  };

  scrollSlowDown = () => {
    if (this.state.isMouseDown) return;
    if (this.isMagneticallyScrolling) return;

    let currTime = Date.now();
    let timeDelta = currTime - this.updateTime;
    let distDelta = (this.speedY * this.speedMultiplier) * timeDelta;
    // console.log(distDelta);

    let newScrollTop = this._carouselWrapper.current.scrollTop - distDelta;
    this.checkArrowVisibility(newScrollTop);
    this._carouselWrapper.current.scrollTop = newScrollTop;
    this._carouselWrapper.current.scrollLeft = newScrollTop * this.scrollRatio;

    this.speedY *= this.damping;
    // if (Math.abs(this.speedX) < 0.1) {
    //   this.speedX = 0;
    //   this.setState({ isScrolling: false });
    // }
    if (Math.abs(this.speedY) < 1.0) {
      // let singleItemScrollLeft = this.state.itemGapX;
      let currScrollTop = this._carouselWrapper.current.scrollTop;
      let magnetScrollTopTarget =
        this.singleItemScrollTop * this.magnetScrollTargetIndex;
      let scrollTopAmt = magnetScrollTopTarget - currScrollTop;

      // Are we scrolling in the same direction as the magnetic scroll target item?
      if (Math.sign(this.speedY) !== Math.sign(scrollTopAmt)) {
        this.getNearestItem();
        this.scrollTimeMultiplier = 1.0;
        this.startScrollMagnetically();
        return;
      } else {
        this.speedY *= this.damping; // Double the damping
        if (Math.abs(this.speedY) < 0.1) {
          this.getNearestItem();
          this.scrollTimeMultiplier = 1.0;
          this.startScrollMagnetically();
          return;
        }
      }
    }

    this.updateTime = currTime;
    requestAnimationFrame(this.scrollSlowDown);

    this.getNearestItem();
  };

  getNearestItem = () => {
    let currScrollTop = this._carouselWrapper.current.scrollTop;
    // let singleItemScrollLeft = this.state.itemGapX;
    let nearestItem = Math.round(currScrollTop / this.singleItemScrollTop);
    if (nearestItem < 0) nearestItem = 0;
    if (nearestItem >= this.props.children.length)
      nearestItem = this.props.children.length - 1;
    this.magnetScrollTargetIndex = nearestItem;

    // console.log("currScrollLeft", currScrollTop);
    // console.log("singleItemScrollLeft", this.singleItemScrollTop);
    // console.log("nearestItem", nearestItem);
    // console.log("this.magnetScrollTargetIndex", this.magnetScrollTargetIndex);
  };

  startScrollMagnetically = () => {
    let currScrollTop = this._carouselWrapper.current.scrollTop;
    this.magnetStartTime = Date.now();
    this.magnetScrollTopInitial = currScrollTop;
    this.setState({ isScrolling: true });
    this.isMagneticallyScrolling = true;

    console.log("this.magnetScrollTopInitial", this.magnetScrollTopInitial);
    console.log("this.magnetScrollTargetIndex", this.magnetScrollTargetIndex);
    requestAnimationFrame(this.scrollMagnetically);
  };

  scrollMagnetically = () => {
    if (this.state.isMouseDown) return;
    if (!this.isMagneticallyScrolling) return;

    let isDone = false;
    let percent =
      (Date.now() - this.magnetStartTime) /
      (this.magnetScrollTime * this.scrollTimeMultiplier * 1000);
    if (percent > 1.0) {
      percent = 1.0;
      isDone = true;
    }
    // let sqPercent = percent * percent;
    // let easeInOutPercent =  sqPercent / (2.0 * (sqPercent - percent) + 1.0);
    let easeInOutPercent = percent * percent * (3.0 - 2.0 * percent);

    // let singleItemScrollLeft = this.state.itemGapX;
    let magnetScrollTopTarget =
      this.singleItemScrollTop * this.magnetScrollTargetIndex;
    let scrollTopAmt =
      (magnetScrollTopTarget - this.magnetScrollTopInitial) * easeInOutPercent;
    let newScrollTop = this.magnetScrollTopInitial + scrollTopAmt;
    this._carouselWrapper.current.scrollTop = newScrollTop;
    this._carouselWrapper.current.scrollLeft = newScrollTop * this.scrollRatio;

    // console.log(percent, easeInOutPercent);

    if (!isDone) {
      requestAnimationFrame(this.scrollMagnetically);
    } else {
      this.setState({ isScrolling: false });
      this.isMagneticallyScrolling = false;
    }
  };

  onMouseWheel = (e) => {
    if (Math.abs(e.deltaY) < 20) return;
    // this.speedX = -0.5 * e.deltaY;
    // this.updateTime = Date.now();
    // this.setState({ isScrolling: true });
    // requestAnimationFrame(this.scrollSlowDown);

    if (this.isMagneticallyScrolling) return;
    console.log("onMouseWheel", e.deltaY);

    this.getNearestItem();
    if (e.deltaY > 0)
      this.magnetScrollTargetIndex = Math.min(
        this.magnetScrollTargetIndex + 1,
        this.props.children.length - 1
      );
    else if (e.deltaY < 0) {
      this.magnetScrollTargetIndex = Math.max(
        this.magnetScrollTargetIndex - 1,
        0
      );
    }
    this.scrollTimeMultiplier = 0.5;
    this.startScrollMagnetically();
    // requestAnimationFrame(this.scrollMagnetically);
    console.log(
      "this.magnetScrollTargetIndex srollwheel",
      this.magnetScrollTargetIndex
    );

    // let newScrollLeft = this._carouselWrapper.current.scrollLeft + e.deltaY;
    // this.checkArrowVisibility(newScrollLeft);
    // this._carouselWrapper.current.scrollLeft = newScrollLeft;
    // this._carouselWrapper.current.scrollTop = newScrollLeft / this.scrollRatio;
    // this.setState({ isScrolling: true });

    e.stopPropagation();
    e.preventDefault();
  };

  scrollLeft = (e) => {
    console.log("left");
    this.speedY = 3.0;
    this.updateTime = Date.now();
    this.setState({ isScrolling: true });
    requestAnimationFrame(this.scrollSlowDown);
    // let newScrollLeft = this._carouselWrapper.current.scrollLeft - 480;
    // this.checkArrowVisibility(newScrollLeft);
    // this._carouselWrapper.current.scrollLeft = newScrollLeft;
    // this._carouselWrapper.current.scrollTop =
    //   newScrollLeft / this.ratioContainer;
  };

  scrollRight = () => {
    console.log("right");
    this.speedY = -3.0;
    this.updateTime = Date.now();
    this.setState({ isScrolling: true });
    requestAnimationFrame(this.scrollSlowDown);
    // let newScrollLeft = this._carouselWrapper.current.scrollLeft + 480;
    // this.checkArrowVisibility(newScrollLeft);
    // this._carouselWrapper.current.scrollLeft = newScrollLeft;
    // this._carouselWrapper.current.scrollTop =
    //   newScrollLeft / this.ratioContainer;
  };

  checkArrowVisibility = (newScrollTop) => {
    // let newScrollLeft = this._carousel.current.scrollLeft;
    if (newScrollTop <= 0) {
      this.setState({ showLeftArrow: false, showRightArrow: true });
    } else {
      let scrollMax =
        this._carouselWrapper.current.scrollHeight -
        this._carouselWrapper.current.clientHeight;
      if (newScrollTop >= scrollMax) {
        this.setState({ showLeftArrow: true, showRightArrow: false });
      } else {
        this.setState({ showLeftArrow: true, showRightArrow: true });
      }
    }
  };

  onResize = () => {
    this.updateSizing();
    setTimeout(() => {
      this.updateSizing();
    }, 100);
    setTimeout(() => {
      this.updateSizing();
    }, 250);
  };

  updateSizing = () => {
    if (!this._carouselContainer || !this._carouselContainer.current) return;

    // let carouselContainerWidth =
    //   this._carouselContainer.current.getBoundingClientRect().width;
    // let carouselContainerHeight =
    //   this._carouselContainer.current.getBoundingClientRect().height;

    let carouselWrapperWidth =
      this._carouselWrapper.current.getBoundingClientRect().width;
    let carouselWrapperHeight =
      this._carouselWrapper.current.getBoundingClientRect().height;

    // console.log(carouselContainerWidth + " x " + carouselContainerHeight);
    // console.log(carouselWrapperWidth + " x " + carouselWrapperHeight);
    // this.ratioContainer =
    //   (carouselContainerWidth - carouselWrapperWidth) /
    //   (carouselContainerHeight - carouselWrapperHeight);

    let itemWidth;
    let itemHeight;
    let itemGapXPx;
    let itemGapYPx;
    let wrapperPaddingX;
    let wrapperPaddingY;

    if (carouselWrapperHeight > carouselWrapperWidth) {
      if (this.itemAspect > 1.0) {
        this.itemAspect = 1.0 / this.itemAspect;
      }
      this.props.setIsLandscape(false);
      console.log("Mobile!!!!!");
      this.isMobile = true;
    } else {
      if (this.itemAspect < 1.0) {
        this.itemAspect = 1.0 / this.itemAspect;
      }
      this.props.setIsLandscape(true);
      this.isMobile = false;
    }
    if (this.itemAspect >= 1.0) {
      itemHeight = Math.min(
        carouselWrapperWidth / this.itemAspect,
        carouselWrapperHeight * this.itemMaxHeightRatio
      );
      itemWidth = itemHeight * this.itemAspect;
      if (!this.isMobile) {
        itemGapXPx = itemWidth * this.itemGapXRatio;
      } else {
        itemGapXPx = 0;
      }
      itemGapYPx = this.itemGapY;
      if (this.isMobile) itemGapYPx *= 2.0;
      wrapperPaddingX = (carouselWrapperWidth - itemWidth) / 2.0;
      wrapperPaddingY = (carouselWrapperHeight - itemHeight) / 2.0;
      this.scrollRatio = itemGapXPx / (itemGapYPx + itemHeight);
      // this.singleItemScrollLeft = itemGapXPx;
      this.singleItemScrollTop = itemGapYPx + itemHeight;
    } else {
      // Mobile
      itemWidth = Math.min(
        carouselWrapperHeight * this.itemAspect,
        carouselWrapperWidth * this.itemMaxWidthRatio
      );
      itemHeight = itemWidth / this.itemAspect;
      itemGapXPx = this.itemGapY;
      itemGapYPx = itemHeight * this.itemGapXRatio;
      wrapperPaddingX = (carouselWrapperWidth - itemWidth) / 2.0;
      wrapperPaddingY = (carouselWrapperHeight - itemHeight) / 2.0;
      this.scrollRatio = (itemGapXPx + itemWidth) / itemGapYPx;
      // this.singleItemScrollLeft = itemGapXPx + itemWidth;
      this.singleItemScrollTop = itemGapYPx;
    }
    this.setState({
      itemWidth,
      itemHeight,
      itemGapX: itemGapXPx,
      itemGapY: itemGapYPx,
      wrapperPaddingX,
      wrapperPaddingY,
    });

    // console.log("itemWidth", itemWidth);
    // console.log("itemHeight", itemHeight);
    // console.log("itemGapX", itemGapX);
    // console.log("itemGapY", itemGapY);
    // console.log("wrapperPaddingX", wrapperPaddingX);
    // console.log("wrapperPaddingY", wrapperPaddingY);
    // console.log("scrollRatio", this.scrollRatio);
  };

  render() {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflowX: "hidden",
          ...this.props.style,
        }}
      >
        {/* <button
          className="custom-carousel-arrow custom-carousel-arrow-left"
          style={{
            visibility: this.state.showLeftArrow ? "visible" : "hidden",
          }}
          onClick={this.scrollLeft}
        >
          ❮
        </button> */}
        <div
          className="custom-carousel-wrapper"
          ref={this._carouselWrapper}
          // style={{
          //   scrollBehavior:
          //     this.state.isMouseDown || this.state.isScrolling
          //       ? "unset"
          //       : "smooth",
          // }}
        >
          <div
            className="custom-carousel-container"
            ref={this._carouselContainer}
            style={{
              display: "flex",
              flexDirection: this.itemAspect >= 1.0 ? "column" : "row",
              paddingLeft: `${this.state.wrapperPaddingX}px`,
              paddingTop: `${this.state.wrapperPaddingY}px`,
              paddingRight: `${this.state.wrapperPaddingX}px`,
              paddingBottom: `${this.state.wrapperPaddingY}px`,
            }}
          >
            {this.props.children.map((child, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: `${this.state.itemWidth}px`,
                    height: `${this.state.itemHeight}px`,
                    marginLeft:
                      this.itemAspect >= 1.0
                        ? `${this.state.itemGapX * index}px`
                        : index === 0
                        ? "0"
                        : `${this.state.itemGapX}px`,
                    marginTop:
                      this.itemAspect >= 1.0
                        ? index === 0
                          ? "0"
                          : `${this.state.itemGapY}px`
                        : `${this.state.itemGapY * index}px`,
                  }}
                  className="custom-carousel-item"
                >
                  {child}
                </div>
              );
            })}
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            top: "2.5rem",
            left: this.isMobile ? "1rem" : "calc(50% - 3rem)",
            color: "white",
            width: "6rem",
            // height: "2rem",
            padding: "0.25rem",
            textAlign: "center",
          }}
        >
          {this.magnetScrollTargetIndex < this.props.children.length
            ? this.magnetScrollTargetIndex + 1
            : this.props.children.length}
          /{this.props.children.length}
        </div>

        {/* <div
          style={{
            position: "absolute",
            bottom: "1rem",
            left: "1rem",
            width: "2rem",
            height: "2rem",
            borderRadius: "50%",
            backgroundColor: this.state.isMouseDown ? "green" : "white",
          }}
        ></div>

        <div
          style={{
            position: "absolute",
            bottom: "1rem",
            left: "3.5rem",
            width: "2rem",
            height: "2rem",
            borderRadius: "50%",
            backgroundColor: this.state.isScrolling ? "green" : "white",
          }}
        ></div>

        <div
          style={{
            position: "absolute",
            bottom: "3.5rem",
            left: "1rem",
            width: "10rem",
            height: "2rem",
            color: "white",
          }}
        >
          {this.speedY}
        </div> */}

        {/* <button
          className="custom-carousel-arrow custom-carousel-arrow-right"
          style={{
            visibility: this.state.showRightArrow ? "visible" : "hidden",
          }}
          onClick={this.scrollRight}
        >
          ❯
        </button> */}
      </div>
    );
  }
}
